import { useEffect, useState } from "react";

const useDocTitle = title => {
  const [doctitle, setDocTitle] = useState(title);

  useEffect(() => {
    document.title = doctitle;
  }, [doctitle]);

  return [doctitle, setDocTitle];
};

// SEO Hook für Meta-Tags
const useSEO = (title, description, keywords = "", image = "") => {
  useEffect(() => {
    // Title setzen
    document.title = title;
    
    // Meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = description;
    
    // Meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.name = 'keywords';
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.content = keywords;
    
    // Open Graph Tags
    const ogTags = {
      'og:title': title,
      'og:description': description,
      'og:image': image || '/logo512.png',
      'og:url': window.location.href
    };
    
    Object.entries(ogTags).forEach(([property, content]) => {
      let ogTag = document.querySelector(`meta[property="${property}"]`);
      if (!ogTag) {
        ogTag = document.createElement('meta');
        ogTag.setAttribute('property', property);
        document.head.appendChild(ogTag);
      }
      ogTag.content = content;
    });
    
    // Twitter Card Tags
    const twitterTags = {
      'twitter:title': title,
      'twitter:description': description,
      'twitter:image': image || '/logo512.png'
    };
    
    Object.entries(twitterTags).forEach(([property, content]) => {
      let twitterTag = document.querySelector(`meta[property="${property}"]`);
      if (!twitterTag) {
        twitterTag = document.createElement('meta');
        twitterTag.setAttribute('property', property);
        document.head.appendChild(twitterTag);
      }
      twitterTag.content = content;
    });
    
    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = window.location.href;
    
  }, [title, description, keywords, image]);
};

export { useDocTitle, useSEO };